module.exports = {"451323100":"武宣镇","451323101":"桐岭镇","451323102":"通挽镇","451323103":"东乡镇","451323104":"三里镇","451323105":"二塘镇","451323106":"黄茆镇","451323107":"禄新镇","451323108":"思灵镇","451323204":"金鸡乡","451323401":"黔江农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451323.json
// module id = 2173
// module chunks = 0